<template>
  <slot v-bind="{ accordionState }"></slot>
</template>

<script>
export default {
  props: {
    openFirst: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      accordionState: {
        count: 0,
        active: this.openFirst ? 0 : null,
      }
    }
  },
  provide() {
    return { accordionState: this.accordionState }
  }
}
</script>

<style lang="scss" scoped></style>
